"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LinkButton = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const classNames_1 = require("../../../utils/classNames");
const theme_1 = require("../../../utils/theme");
const LinkButton = ({ fullWidth, ...props }) => {
    const { children, className, href, palette = 'primary', shadow, target, shape = 'md', size = 'md', variant = 'contained', } = props;
    const theme = (0, theme_1.useTheme)();
    const sizeClasses = theme.components.buttonLink.size[size || 'md'];
    const shapeClasses = theme.components.buttonLink.shape[shape || 'md'];
    const paletteClasses = variant === 'contained'
        ? [
            ...theme.palette[palette || 'none'].background,
            ...theme.palette[palette || 'none'].hover,
            ...theme.palette[palette || 'none'].textLight,
        ]
        : [
            ...theme.palette[palette || 'none'].outlined,
            ...theme.palette[palette || 'none'].textOutlined,
        ];
    const variantClasses = [
        ...theme.components.buttonLink.variant[variant || 'contained'],
    ];
    const shadowClasses = shadow
        ? theme.components.buttonLink.shadow[size || 'md']
        : undefined;
    const baseClassName = (0, classNames_1.cn)('inline-flex', 'items-center', 'justify-center', { 'w-full': fullWidth }, sizeClasses, shapeClasses, shadowClasses, paletteClasses, variantClasses, className);
    return ((0, jsx_runtime_1.jsx)("a", { ...props, href: href || '#', target: target || '_self', className: baseClassName, children: children }));
};
exports.LinkButton = LinkButton;
